module.exports = __webpack_public_path__ + "img/组 126(8)(1).b48c9e21.png";